<template>
  <div class="grid-wrap">
    <div class="grid-row">
      <article class="push__bottom">
        <div class="grid-col grid-col--soft grid-xsmall-12 grid-large-9">
            <BackLink/>
            <Section :section="this.sectionId" />
        </div>                
        <Form
          :data="form"
          :error="$v.form.$error"
          :formId="question.id"
          :formErrorMessage="errorMessage"
          @submit="submitNameAndGender"
        >
          <Fieldset 
            :title="question">
            
            <Textarea
              id="briefdescription"
              name="briefdescription"
              label="Please briefly describe your current problem"
              type="textarea"
              errorMessage="Brief description is a required field"
              v-model="form.briefDescription"
              :validate="$v.form.briefDescription"
            />

          </Fieldset>
        </Form>
      </article>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import Textarea from '../components/Forms/Textarea.vue';
import { dataService } from "../shared";

export default {
  components: { Textarea },
  name: "home",
  props: {
        title: String
  },
  data() {
        return {
            selected: null,
            id: "",
            sectionId: null,
            question: "",
            answer: null,
            errorMessage: "All fields are required",
            destination: "",
            options: [],
            form: {
                briefDescription: null,
                nextUrl: null,
            }
        };
    },
    created() {
        this.loadQuestion();
    },  
    mounted() {
        this.loadAnswer();
    },
    validations: {
        form: {
            briefDescription: {required}
        }
    },
    methods: {	
        submitForm(form, valid) {
            valid.$touch();
            if (valid.$pending || valid.$error) {
                setTimeout(() => {
                    document.querySelector(".error-summary__link").focus()
                }, 0);
                return;	
            }    
            this.logResponse();  
            if (dataService.canShowSummary())
            {
                this.$router.push({ name: "summary" });
            }
            else
            {
                this.$router.push({ name: this.destination.toLowerCase() });
            }
        },
        submitNameAndGender() {
            this.submitForm(this.form, this.$v.form);
        },
        loadQuestion() {
            let json = dataService.getQuestions();
            let questions = json.questions;
            let currentQuestion = dataService.findElement(
                questions,
                dataService.parseUrl()
            );
            this.id = currentQuestion.id;
            this.sectionId = currentQuestion.sectionId;
            this.question = currentQuestion.question;
            this.options = currentQuestion.options;
            this.destination = currentQuestion.destination;
            this.errorMessage = currentQuestion.errorMessage;
            let previousResponse = dataService.wasAnsweredBefore(currentQuestion.id);
            if (previousResponse) {
                this.form.id = previousResponse.id;
                this.form.briefDescription = previousResponse.briefDescription;
            }
        },    
        loadAnswer() {
        },
        logResponse() {
            let response = {
                id: this.id,
                questionType: "BriefDescription",
                briefDescription: this.form.briefDescription
            };
            dataService.logResponse(response);
        },
        redirectToTimeout() {
            dataService.resetResponses();
            this.$router.push({ name: "timeout" });
        }
    }
};
</script>